import { Grid, Typography } from '@mui/material'
import { Keywords } from '../inputs/Keywords'
import { LongDescription } from '../inputs/LongDescription'
import { Title } from '../inputs/Title'

export const TextSearch = () => (
  <Grid container spacing={1}>
    <Grid size={12}>
      <Typography variant="h2">Text Search</Typography>
    </Grid>
    <Grid size={{ sm: 12, lg: 3 }}>
      <Title />
    </Grid>
    <Grid size={{ sm: 12, lg: 3 }}>
      <Keywords />
    </Grid>
    <Grid size={{ sm: 12, lg: 'grow' }}>
      <LongDescription />
    </Grid>
  </Grid>
)
